export default {

	async page_list () {

		const list = await Anvil.models.CompanyGroupList.fetch()

		await Anvil.renderPage('/company_group/page_list', { list })
	},

	async action_refresh () {

		const list = await Anvil.models.CompanyGroupList.fetch()

		Anvil.page.list = list
		Anvil.models.components.Grid.find('#company_group_grid').list = list
	},

	async modal_edit (id) {

		const company_group = await Anvil.models.CompanyGroup.fetch(id)

		await Anvil.modal('/company_group/modal_edit', { company_group })
	},

	async action_save (company_group) {

		// Tell the record to commit
		await company_group.record.commit()

		Anvil.toast.success('Elmentve', 'Az cégcsoport mentése sikeres')

		// Refresh list
		await this.action_refresh()

		// Focus on company_group
		let grid = Anvil.models.components.Grid.find('#company_group_grid')
		grid.select(grid.list.getById(company_group.id), true)

		return true
	},

	async action_delete (id, confirm = false) {

		// Megerősítés kérése
		if (!confirm) {
			Anvil.confirm({
				title: 'Törlés megerősítése',
				message: '<p>Valóban törölni szeretné a kijelölt cégcsoportot?</p>',
				btn_ok: '<i class="fas fa-trash me-2"></i>Törlés',
				btn_ok_class: 'danger',
				btn_cancel: '<i class="fas fa-times me-2"></i>Mégsem',
				onclose: (confirmed) => {
					if (confirmed) {
						Anvil.exec('company_group/action_delete', id, true)
					}
				}
			})
			return
		}

		console.log('delete')
		await Anvil.models.CompanyGroup.delete(id)

		Anvil.toast.success('Törölve', 'A cégcsoport törlése sikeres')

		// Refresh list
		await this.action_refresh()
	}
}
